import { graphql } from '@search/gql-client/src';

export const UnsubscribeFromOfferPriceChangeMutation = graphql`
mutation UnsubscribeFromOfferPriceChangeMutation(
    $offerId: ID!,
) {
    unsubscribeFromPriceChangePersonal(
        offerId: $offerId,
    ) {
        isUnsubscribed
        firstError {
            __typename
            ... on BaseError {
                message
            }
            ... on AuthUserIdError {
                message
            }
            ... on UnsubscribeFromPriceChangePersonalErrorInvalidId {
                message
            }
            ... on UnsubscribeFromPriceChangePersonalErrorNotExists {
                message
            }
        }
    }
}
`;
